import { crewMemberNoneAvailable } from 'pages/CrewMemberDetails/components/Info/const';
import { formatWeekdayDate } from 'utils/datetime';

export const mapHoldDownsToRows = (holdDowns = [], employeeInfo) =>
	holdDowns.map((holdDown) => {
		const {
			id,
			effectiveTimestamp,
			expireTimestamp,
			originalCrewMember,
			crewMember,
			note,
			createdAt,
			updatedBy: createdBy,
		} = holdDown;

		const startDate =
			effectiveTimestamp != null ? formatWeekdayDate(effectiveTimestamp) : crewMemberNoneAvailable;
		const endDate =
			expireTimestamp != null ? formatWeekdayDate(expireTimestamp) : crewMemberNoneAvailable;
		const created = createdAt != null ? formatWeekdayDate(createdAt) : crewMemberNoneAvailable;
		const isReplacedHoldDown = originalCrewMember?.id === employeeInfo?.id;

		return {
			id,
			startDate,
			endDate,
			created,
			createdBy,
			note,
			driverId: isReplacedHoldDown ? crewMember?.id : originalCrewMember?.id,
			driver: isReplacedHoldDown
				? `Replaced by: ${crewMember?.fullName}`
				: `Replacing: ${originalCrewMember?.fullName}`,
			originalCrewMember,
			crewMember,
		};
	});
